import React, { Fragment, useState, useEffect, useContext } from "react";
import Select from "react-select";
import styles from '../../assets/css/module/common/common.module.css';
import Modal from "../modal/Modal";
import { FindOption, setValue } from "../common/helpers";
import { contextValues } from "../../components/context/context-master";
const StylesComponent = require('../select/select-dropdown-custom-style');
const customStyles = StylesComponent.customStyles2();

const ContactUsWA = (props) => {
  const [optionsService, setOptionsService] = useState([])
  const [v_service, setService] = useState({ label: "", value: "" })
  const [s_service, setS_Service] = useState("")
  const [v_name, setName] = useState("")
  const [s_name, setS_Name] = useState("form-control")
  const [v_message, setMessage] = useState("")
  const [s_message, setS_Message] = useState("form-control")
  const language = localStorage.getItem('language')

  function getOptionsService() {
    const options = [
      {
        label: "Select Category",
        options: [
          { label: "AMO Smartaviation", value: 1, phone: '6281383895268' },
          { label: "Aerial Survey", value: 2, phone: '6281383895268' },
          { label: "Weather Modification Technology", value: 3, phone: '6281383895268' },
          { label: "Exclusive Airplane Rent", value: 4, phone: '6281383895268' },
          { label: "Pioneer Flight", value: 5, phone: '6281383895268' },
          { label: "Other", value: 0, phone: '6281383895268' },
        ]
      }
    ]
    setOptionsService(options)
  }

  function setFullName(e) {
    setValue(e.target.value, setName, v_name, setS_Name, 'form-control', 'form-control-err', /^[A-Za-z_\-',.\s]*$/, false)
  }

  function setMessages(e) {
    setValue(e.target.value, setMessage, v_message, setS_Message, 'form-control', 'form-control-err', /^[A-Za-z0-9_\-':;%$&(),.\s]*$/, false)
  }

  function check() {
    let result = true;

    if (v_name === '') {
      result = false
      setS_Name('form-control-err')
    }

    if (v_message === '') {
      result = false
      setS_Message('form-control-err')
    }

    if (v_service.value === '') {
      result = false
      setS_Service('form-select-err')
    }

    return result;
  }

  function sendWA() {
    if (check()) {
      // let m_c1 = encodeURIComponent('Hallo Smart Aviation,')
      // let m_c2 = encodeURIComponent(`\n\nKategori : ${v_service.label}\n\nSaya ${v_name},\n${v_message}`)
      let m_c3 = ''
      if (language === 'id') {
        m_c3 = encodeURI(`Kategori : ${v_service.label}\n\nHallo Smart Aviation,\n\nSaya ${v_name},\n${v_message}`)
      } else {
        m_c3 = encodeURI(`Category : ${v_service.label}\n\nHallo Smart Aviation,\n\nI'm ${v_name},\n${v_message}`)
      }


      // let url = `https://api.whatsapp.com/send/?phone=${v_service.phone}&text=${m_c3}&type=phone_number&app_absent=0`
      let url = `https://wa.me/${v_service.phone}?text=${m_c3}`
      // console.log(url);
      window.open(url, '_blank', "noreferrer");
      props.toggleHandler()
    }
  }

  useEffect(() => {
    getOptionsService()
  }, []);


  return (
    <Fragment>
      <Modal
        isOpen={props.modal}
        toggle={props.toggleHandler}
        title='Contact Us on Whatsapp'
        className={styles['modal-w-20']}
        body={
          <Fragment>
            <div className={`${styles["modal-wa-body"]} ${styles["row"]}`}>
              <div className={`${styles["col-1"]}`}>
                <input
                  className={`${styles[s_name]}`}
                  placeholder="Enter Fullname"
                  type="text"
                  onChange={setFullName}
                  value={v_name}
                />
              </div>
              <div className={`${styles["col-1"]}`}>
                <Select
                  className={`${styles[s_service]}`}
                  value={FindOption(v_service.value, optionsService[0])}
                  onChange={e => setService(e)}
                  options={optionsService}
                  placeholder="Select Category"
                  styles={customStyles}
                />
              </div>
              <div className={`${styles["col-1"]}`}>
                <textarea
                  className={`${styles[s_message]} ${styles["txt-area"]}`}
                  rows="4"
                  maxLength="100"
                  placeholder="Enter Your Message"
                  onChange={setMessages}
                  value={v_message}
                />
              </div>
            </div>
          </Fragment>
        }
        footer={
          <Fragment>
            <button className={`${styles['modal-btn']} ${styles['btn']}`} onClick={() => sendWA()}>Contact Us</button>
          </Fragment>
        }
        classNameFooter={styles['modal-footer-wa']}
      />
    </Fragment>
  )
}

export default ContactUsWA
